import axios from 'axios'
import { ElMessage } from 'element-plus'
import { getToken, removeToken } from '@/utils/auth'
import { getApiBaseUrl } from '@/utils/serviceBase'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const service = axios.create({
  // axios涓姹傞厤缃湁baseURL閫夐」锛岃〃绀鸿姹俇RL鍏叡閮ㄥ垎
  baseURL: getApiBaseUrl(),
  // 瓒呮椂
  timeout: 0
})

// request鎷︽埅鍣?
service.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers['Authorization'] = 'bearer ' + getToken()
  }
  // console.log('request鎷︽埅鍣?- config', config)
  return config
}, error => {
  return Promise.reject(error)
})

export default service
